import { render } from "./Involvements.vue?vue&type=template&id=1fc23e7a"
import script from "./Involvements.vue?vue&type=script&lang=js"
export * from "./Involvements.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__